import React from 'react';
import { UserPlusGlyph, MaterialGlyph } from './icons';

// Two empty shapes:
//  - noMaterials: the company hasn't created any walkthroughs/paths yet
//  - otherwise: materials exist but no learners have been invited yet
const EmptyState = ({ materialType, noMaterials, onInviteUsers }) => {
  const noun = materialType === 'paths' ? 'path' : 'walkthrough';
  const nounPlural = materialType === 'paths' ? 'paths' : 'walkthroughs';

  if (noMaterials) {
    return (
      <div className="ma-empty">
        <span className="ma-empty__icon"><MaterialGlyph size={28} /></span>
        <h3 className="ma-empty__title">No {nounPlural} yet</h3>
        <p className="ma-empty__text">
          Create your first {noun} to start inviting learners and tracking their progress here.
        </p>
      </div>
    );
  }

  return (
    <div className="ma-empty">
      <span className="ma-empty__icon"><UserPlusGlyph size={26} /></span>
      <h3 className="ma-empty__title">No learners invited yet</h3>
      <p className="ma-empty__text">
        Invite people to your {nounPlural} and you&apos;ll see who has access and where they are in the journey.
      </p>
      <button type="button" className="ma-btn ma-btn--primary" onClick={onInviteUsers}>
        <UserPlusGlyph /> Invite users
      </button>
    </div>
  );
};

export default EmptyState;
